export const GET_USER_INFO = "GET_USER_INFO";
export const UPDATE_USER_INFO = "GET_USER_INFO";
export const DELETE_USER_INFO = "DELETE_USER_INFO";
export const UPDATE_PHONE_USER = "UPDATE_PHONE_USER";
export const CLEAR_UPDATE_PHONE = "CLEAR_UPDATE_PHONE";
export const ERROR_PHONE = "ERROR_PHONE";

